import React from 'react';

import ProgressOverlay from './overlays/progress_overlay';

// Not sure the right way to do this with typescript, so theres errors in this file
export type BusyState = {
  is_busy: boolean;
};
export class BusyComponent<P, S extends BusyState> extends React.PureComponent<
  P,
  S
> {
  _isBusy = false;
  setBusy(): boolean {
    let ret = !this._isBusy;
    if (ret) {
      this._isBusy = true;
      this.setState({ is_busy: true });
    }
    return ret;
  }
  clearBusy(): void {
    this._isBusy = false;
    this.setState({ is_busy: false });
  }
}

type OverlayProps = {
  style?: any;
  isBusy: boolean;
};

export function BusyOverlay(props: OverlayProps) {
  const { style, isBusy } = props;
  let content: any = null;
  if (isBusy) {
    content = <ProgressOverlay style={style} color='white' />;
  }
  return content;
}

export function useBusy(
  default_value?: boolean
): [boolean, () => boolean, () => void, () => boolean] {
  const [is_state_busy, setStateBusy] = React.useState(default_value ?? false);
  const is_busy = React.useRef(default_value ?? false);
  function setBusy(): boolean {
    let ret = false;
    if (!is_busy.current) {
      is_busy.current = true;
      setStateBusy(true);
      ret = true;
    }
    return ret;
  }
  function clearBusy() {
    is_busy.current = false;
    setStateBusy(false);
  }
  function isBusy() {
    return is_busy.current;
  }
  return [is_state_busy, setBusy, clearBusy, isBusy];
}
